import { render, staticRenderFns } from "./v-aside.vue?vue&type=template&id=75ec104a&scoped=true&"
import script from "./v-aside.vue?vue&type=script&lang=js&"
export * from "./v-aside.vue?vue&type=script&lang=js&"
import style0 from "./v-aside.vue?vue&type=style&index=0&id=75ec104a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ec104a",
  null
  
)

export default component.exports